'use client'
import { jsx, jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useRef } from "react";
import { format, isBefore, isValid } from "date-fns";
import { isDateRange, useDayPicker } from "react-day-picker";
import { cn } from "../../../utils/index.js";
import { CdnIcon } from "../../CdnIcon/index.js";
import { DayMapContext } from "../Providers/DayMapProvider.js";
const CALENDAR_DAY_FORMAT = 'yyyyMMdd';
function HeatMapDayButton(props) {
    const { day, modifiers, ...buttonProps } = props;
    const dayMapContext = useContext(DayMapContext);
    const { dayMap = {}, mode } = dayMapContext || {};
    const { classNames, selected, dayPickerProps } = useDayPicker();
    const { disabled } = dayPickerProps;
    const { variant = 'Day', data: dayMapData } = dayMap;
    const currentDate = format(day.date, 'd');
    const ref = useRef(null);
    useEffect(()=>{
        if (modifiers.focused) ref.current?.focus();
    }, [
        modifiers.focused
    ]);
    let subText = null;
    let disableDate = false;
    if ('object' == typeof disabled && null !== disabled && 'before' in disabled && isValid(disabled.before)) disableDate = isBefore(day.date, disabled.before);
    let customClasses = dayMapData ? 'flex flex-col justify-start' : '';
    if ('dayHeatMap' === variant) customClasses = `${customClasses} border-primary-1 border-1 py-[2px]`;
    if ('dayBelowAvg' === variant) customClasses = `${customClasses} py-1`;
    if (dayMapData && !disableDate) {
        let selectedDate = '';
        if ('range' === mode && selected?.from && isDateRange(selected) && isValid(selected.from)) selectedDate = format(selected.from, CALENDAR_DAY_FORMAT);
        if ('single' === mode && selected && isValid(selected)) selectedDate = format(selected, CALENDAR_DAY_FORMAT);
        const formattedPriceDate = format(day.date, CALENDAR_DAY_FORMAT);
        const formattedPrice = dayMapData[formattedPriceDate]?.price;
        const selectedPrice = dayMapData[selectedDate]?.price;
        if ('dayHeatMap' === variant) {
            let bgColor = "bg-caution-3";
            if (selectedPrice && formattedPrice < selectedPrice) bgColor = 'bg-success-3';
            if (selectedPrice && formattedPrice > selectedPrice) bgColor = 'bg-error-3';
            subText = /*#__PURE__*/ jsx("span", {
                className: "text-body3",
                children: formattedPrice
            });
            customClasses = `${customClasses} ${bgColor}`;
        }
        if ('dayBelowAvg' === variant) subText = selectedPrice && formattedPrice < selectedPrice ? /*#__PURE__*/ jsx("span", {
            className: "text-success-8 text-label",
            children: "\u23FA"
        }) : null;
        if ('dayIcon' === variant) subText = /*#__PURE__*/ jsx(CdnIcon, {
            iconName: "chevron_right",
            size: "20"
        });
    }
    const classes = cn(classNames.day_button, customClasses);
    return /*#__PURE__*/ jsxs("button", {
        ...buttonProps,
        ref: ref,
        className: classes,
        children: [
            /*#__PURE__*/ jsx("span", {
                children: currentDate
            }),
            subText
        ]
    });
}
export { HeatMapDayButton };
